export default {
    settings: {
        title: 'Abandoned carts',
        saved: 'Settings saved',
        intro: 'A shopper who leaves items in their cart gets one email some hours later, with a button that puts the cart back. Only shoppers whose address the shop has are reminded: customers who are logged in, and guests who went to the payment page and did not pay. A guest who leaves before ordering cannot be reached.',
        sending: 'Sending.',
        sentLast30: '{n} reminder sent in the last 30 days. | {n} reminders sent in the last 30 days.',
        recoveredLast30: 'The cart link was opened in {n} of them.',
        noSender: 'Nothing is sent: the website has no sender (mail-from) address.',
        timing: 'Timing',
        delayHours: 'Hours after the cart was left',
        delayHoursHint: 'Counted from the last change to the cart, or from the moment a guest went to pay. 1 to 72 hours.',
        repeatAfter: 'Remind the same shopper again after (days)',
        repeatAfterHint: 'Someone who got a reminder within this many days does not get another for a new cart. 0 reminds about every cart.',
        schedule: 'Reminders go out every 15 minutes. A reminder that could not go out is still sent up to {hours} hours late; older carts are never mailed, so switching this on does not email every cart on record.',
        emailText: 'Email text',
        emailTextHelp: "Leave a language blank to use the standard text, written in that language. You can use {shop} and {name} (first name). The greeting, the cart's items, the button and the unsubscribe link are always added.",
        defaultLocale: '(def)',
        subjectPlaceholder: 'Subject (standard: You left something in your cart at %shop%)',
        messagePlaceholder: 'Opening text (standard: You were almost done...)',
    },
};
